import ForgotContainer from './ForgotContainer';

export default ForgotContainer;